import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '../../../../../components/common/Theme/ThemeContext';
import IntentDefinition from './IntentDefinition';
import type { Theme } from './ChatbotIntentsListing';

function intentsListPath(chatbotId?: string): string {
  if (chatbotId) {
    return `/portal/chatbot/${chatbotId}/intents`;
  }
  return '/portal/createchatagent/intents';
}

const IntentDefinitionPage: React.FC = () => {
  const navigate = useNavigate();
  const { chatbotId, intentId } = useParams<{ chatbotId?: string; intentId?: string }>();
  const { theme: portalTheme } = useTheme();
  const theme: Theme = portalTheme === 'white' ? 'light' : 'dark';

  const mode = intentId ? 'edit' : 'create';
  const listPath = intentsListPath(chatbotId);

  const handleBack = () => navigate(listPath);
  const handleSave = () => navigate(listPath);

  return (
    <div className="h-full min-h-0 flex flex-col -m-3">
      <IntentDefinition
        theme={theme}
        chatbotId={chatbotId}
        mode={mode}
        intentId={intentId}
        onBack={handleBack}
        onSave={handleSave}
      />
    </div>
  );
};

export default IntentDefinitionPage;
